// details-modal.js (GUARDED - safe if loaded twice)
(function () {
  if (!window.customElements) return;

  if (customElements.get('details-modal')) return;

  class DetailsModal extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');

      if (!this.detailsContainer || !this.summaryToggle) return;

      this.detailsContainer.addEventListener(
        'keyup',
        (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
      );

      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.querySelector('button[type="button"]')?.addEventListener(
        'click',
        this.close.bind(this)
      );

      this.detailsContainer.addEventListener(
        'focusout',
        this.onFocusOut.bind(this)
      );
    }

    isOpen() {
      return this.detailsContainer?.hasAttribute('open');
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details')?.hasAttribute('open') ? this.close() : this.open(event);
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    open(event) {
      const details = event.target.closest('details');
      if (!details) return;
      details.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      details.querySelector('input, button, a, [tabindex]:not([tabindex="-1"])')?.focus();
    }

    close() {
      if (!this.detailsContainer) return;
      this.detailsContainer.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      this.summaryToggle?.focus();
    }
  }

  customElements.define('details-modal', DetailsModal);
})();
